import { render, staticRenderFns } from "./VCardProPatientAReg1.vue?vue&type=template&id=3ded8ad5"
import script from "./VCardProPatientAReg1.vue?vue&type=script&lang=js"
export * from "./VCardProPatientAReg1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports